import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  GetPreWorkInstructions,
  MoveToPreflight,
} from "../../api/preworkDetailApi/preworkDetailApi";
import { PreWorkInstructionModel } from "../../types/PreWorkInstructionModel";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

interface MoveToPreflightPopupProps {
  isOpen: boolean;
  onClose: (isCancelClick: boolean, tabValue?: number) => void;
  title: string;
  selectedData: any;
  documentStatus: number;
  tabValue?: number;
}

const MoveToPreflightPopup: React.FC<MoveToPreflightPopupProps> = ({
  isOpen,
  onClose,
  title,
  selectedData,
  documentStatus,
  tabValue,
}) => {
  const { showSnackbar } = useSnackbar();
  const [loading, setLoading] = useState<boolean>(false);
  let [instructionData, setInstructionData] = useState<
    PreWorkInstructionModel[]
  >([]);
  const [selectedInstruction, setSelectedInstruction] = useState<string>("0");
  const [selectedJobnumber, setSelectedJobnumber] = useState<string>("0");
  const [validationInstructionMessage, setValidationInstructionMessage] =
    useState<string | null>(null);
  const [validationJobnumberMessage, setValidationJobnumberMessage] = useState<
    string | null
  >(null);

  useEffect(() => {
    getInstruction();
  }, []);

  const handleInstructionDropdownChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedValue = event.target.value as string;
    setSelectedInstruction(selectedValue);
    setValidationInstructionMessage(null);
  };

  const handleJobnumberDropdownChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedValue = event.target.value as string;
    setSelectedJobnumber(selectedValue);
    setValidationJobnumberMessage(null);
  };

  const getInstruction = async () => {
    setLoading(true);
    try {
      const params: PreWorkInstructionModel = {
        PreWorkInstructionId: undefined,
        InstructionName: undefined,
        FileName: undefined,
        InstructionStream: new Uint8Array(),
        AccountPreWorkId: undefined,
        StreamZipFileName: undefined,
        TopreflightJobno: [],
        AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      };
      const response: PreWorkInstructionModel[] = await GetPreWorkInstructions(
        params
      );
      if (response) {
        instructionData = response;
        setInstructionData(response);
        console.log("response", instructionData);
      }
    } catch (error) {
      console.error("Error in GetPreWorkInstructions ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendClick = async () => {
    try {
      setLoading(true);
      if (selectedInstruction === "0") {
        setValidationInstructionMessage("Please select a valid instruction.");
      } else if (selectedJobnumber === "0") {
        setValidationJobnumberMessage("Please select a valid job number.");
      } else {
        //API Call
        setValidationInstructionMessage(null);
        setValidationJobnumberMessage(null);
        let preworkDetails: any[] = [];
        selectedData.PreworkDetails.forEach((element: any) => {
          const PreworkDetails = {
            ParentDocumentID: element.ParentDocumentID,
            DocumentStreamId: element.ParentDocumentStreamID,
            childFileName: element.ChildFileName,
            AccountId: LocalStorageUtil.getItem("accountId"),
            Userid: LocalStorageUtil.getItem("userId"),
            toPreflightJobNumber: element.ToPreflightJobNumber,
            fromPreflightJobNumber: element.FromPreflightJobNumber,
          };
          preworkDetails.push(PreworkDetails);
        });

        const payload = {
          PreworkDetails: preworkDetails,
          InstructionId: selectedInstruction,
          ToPreflighJobNo: selectedJobnumber,
          contextName: LocalStorageUtil.getItem("contextName"),
          ReprocessDocumentStatus: documentStatus,
        };
        const response = await MoveToPreflight(payload);
        if (response) {
          showSnackbar("File moved to 'To Preflight' successfully");
          onClose(false, tabValue);
        }
      }
    } catch (error) {
      console.error("Error in MoveToPreflight ", error);
    } finally {
      setLoading(false);
    }
  };

  //Close the dialog box
  const handleCloseClick = () => {
    onClose(true);
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleCloseClick}
        maxWidth="sm"
        PaperProps={{
          style: {
            height: "67.5%",
            width: "35%",
          },
        }}
      >
        <DialogTitle style={{ backgroundColor: "var(--primary-color)" }}>
          <div
            className="col-sm-12"
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <div
              className="col-sm-11"
              style={{
                display: "flex",
                alignItems: "left",
                gap: "10px",
                color: "var(--aggrid-text-color)",
              }}
            >
              {title}
            </div>
            <div
              className="col-sm-1"
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "right",
              }}
            >
              {" "}
              <Tooltip title="Close">
                <IconButton
                  onClick={() => onClose(true)}
                  style={{
                    cursor: "pointer",
                    alignItems: "flex-end",
                    color: "var(--aggrid-text-color)",
                    width: "20px",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "60%",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-12" style={{ marginTop: "20px" }}>
                Instruction Name: *
              </div>
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                <TextField
                  id="outlined-select-age-days"
                  select
                  defaultValue={"0"}
                  value={selectedInstruction}
                  onChange={handleInstructionDropdownChange}
                  variant="outlined"
                  fullWidth
                  style={{
                    paddingTop: "0px",
                    backgroundColor: "white",
                    display: "inline-block !important",
                    alignItems: "center",
                    fontSize: "11x",
                  }}
                  InputProps={{
                    style: {
                      height: "30px",
                      fontSize: "2x",
                    },
                  }}
                >
                  <MenuItem value="0">Select</MenuItem>
                  {instructionData.map((option: any) => (
                    <MenuItem
                      key={option.preWorkInstructionId}
                      value={option.preWorkInstructionId}
                      style={{ fontSize: "11px" }}
                    >
                      {option.instructionName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              {validationInstructionMessage && (
                <Typography color="error" style={{ marginTop: "10px" }}>
                  {validationInstructionMessage}
                </Typography>
              )}
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                Preflight Job No: *
              </div>
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                <TextField
                  id="outlined-select-age-days"
                  select
                  defaultValue={"0"}
                  value={selectedJobnumber}
                  onChange={handleJobnumberDropdownChange}
                  variant="outlined"
                  fullWidth
                  style={{
                    paddingTop: "0px",
                    backgroundColor: "white",
                    display: "inline-block !important",
                    alignItems: "center",
                    fontSize: "11x",
                  }}
                  InputProps={{
                    style: {
                      height: "30px",
                      fontSize: "2x",
                    },
                  }}
                >
                  <MenuItem value="0">Select</MenuItem>
                  {instructionData.map((option: any, index: number) => (
                    (option.topreflightJobno || []).map((jobNo: string) => (
                    <MenuItem
                      key={option.preWorkInstructionId + "-" + jobNo}
                      value={option.topreflightJobno[index]}
                      style={{ fontSize: "11px" }}
                    >
                      {option.topreflightJobno[index]}
                    </MenuItem>
                    ))
                  ))}
                </TextField>
                {validationJobnumberMessage && (
                  <Typography color="error" style={{ marginTop: "10px" }}>
                    {validationJobnumberMessage}
                  </Typography>
                )}
              </div>
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                File Names
              </div>
              <div className="col-sm-12" style={{ marginTop: "-18px" }}>
                <List>
                  {selectedData.PreworkDetails.map(
                    (detail: any) => (
                      <ListItem key={detail.ChildFileName}>
                        <ListItemIcon sx={{ minWidth: "20px" }}>
                          <FiberManualRecordIcon sx={{ fontSize: "8px" }} />
                        </ListItemIcon>
                        <ListItemText primary={detail.ChildFileName} />
                      </ListItem>
                    )
                  )}
                </List>
              </div>
              <div className="col-sm-12" style={{ marginTop: "8px" }}>
                <p>
                  Your selection contains {selectedData.PreworkDetails.length}{" "}
                  number of files. This move option involves zipping the files
                  and then it will move to the configured FTP/SFTP location.
                </p>
                <p> The larger the format, the longer it will take.</p>
                <p>
                  {" "}
                  Overall entire Move to Preflight of 50 MB files selection,
                  system will take 60 secs under general circumstances.
                </p>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSendClick}
            style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
          >
            Send
          </Button>
          <Button
           style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
            onClick={handleCloseClick}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MoveToPreflightPopup;
